import { ApiService } from "./api.service";

export default class PrintAuthService extends ApiService {
  namespace = "print-check/auth";
  icon = "Lock";
  name = "message";
  favicon = "Padlock";
  window = 290;
  Width = 690;
  DOMAIN = -39;
  singular = this.terminology.invoice.singular;
  plural = this.terminology.invoice.plural;
  vowel = this.terminology.invoice.vowel;
  action = null;

  constructor() {
    super("invoice-settings");
  }
}
